import { Component, EventEmitter, Output } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { CustomModalService } from '@piqet-angular/shared';
import { AdministratorService } from 'libs/data/src/lib/services/administrator/administrator.service';

@Component({
  selector: 'piqet-angular-add-recycled-material',
  templateUrl: './add-recycled-material.component.html',
  styleUrls: ['./add-recycled-material.component.scss'],
})
export class AddRecycledMaterialComponent {
  headerData: any;
  headerName = '';
  modalLabel: any;
  adminRecycledData: any;
  recycledForm!: FormGroup;
  recycledAddEditForm!: FormGroup;
  submitted = false;
  activatedRoute: any;
  organizationList: any;
  recycleList: any;
  regionList: any;
  selectOrganization: any;
  regionData: any;
  selectRegion: any;
  setIndicatorData: any;
  indicatorList: any;
  isHideDropDown!: boolean;
  isDisabledDropDown!: boolean;
  @Output() saveNewRecycleMaterialEvent = new EventEmitter<any>();

  constructor(
    private modal: CustomModalService,
    private formBuilder: FormBuilder,
    private administratorService: AdministratorService
  ) {
    this.adminRecycledData = this.modal?.modalService?.config?.initialState?.['newRecycledData'];
    this.modalLabel = this.modal?.modalService?.config?.initialState?.['label'];
    this.isDisabledDropDown = this.modalLabel == 'Review RMI detail' ? true : false;
    this.recycleList = this.adminRecycledData.materialItems;
    this.regionList = this.adminRecycledData.regionItems;

    const placeHolderOrganization = {
      name: 'All organizations',
    };

    const newOrganizationlist = [placeHolderOrganization].concat(
      this.adminRecycledData.organizationList
    );
    this.organizationList = newOrganizationlist;
    this.indicatorList = this.adminRecycledData.indicatiorList;
    this.organizatioListFunction();
    this.getRegionData();
  }

  ngOnInit(): void {
    const form = [];
    for (let i = 0; i < this.indicatorList.length; i++) {
      form[this.indicatorList[i].name] = new FormControl(
        this.adminRecycledData.indicatiorList[i].defaultValue || 0,
        Validators.required
      );
    }
    this.recycledForm = new FormGroup(form);
    this.recycledAddEditForm = this.formBuilder.group({
      material: [this.adminRecycledData.materialId || null, Validators.required],
      region: [null, Validators.required],
      organizationName: [this.adminRecycledData.organizationId || null],
    });
    this.setFormData();
  }

  onChange(value: any) {
    this.recycledAddEditForm.controls['region'].setValue(null);
    if (!!value?.id) {
      this.administratorService.getRecycledRegions(value.id).subscribe((data: any) => {
        this.regionData = data.data;
      });
    } else {
      this.regionData = [];
    }
  }

  async organizatioListFunction() {
    await this.organizationList?.map((item: any) => {
      if (item.id == this.adminRecycledData.organizationId) {
        return (this.selectOrganization = item);
      }
    });
  }
  async getRegionData() {
    await this.regionList.map((item: any) => {
      if (item.id == this.adminRecycledData.regionId) {
        return (this.selectRegion = item);
      }
    });
  }
  setFormData() {
    this.recycledAddEditForm.patchValue({ region: this.selectRegion });
    this.recycledAddEditForm.patchValue({ organizationName: this.selectOrganization });
  }

  onSave() {
    this.submitted = true;
    if (
      this.recycledAddEditForm.controls['region'].value?.name == '--Select Region-- ' ||
      (this.activatedRoute == 'admin-material' &&
        !this.recycledAddEditForm.controls['region'].value?.name)
    ) {
      return;
    }
    if (this.recycledAddEditForm.status == 'VALID' && this.recycledForm.status == 'VALID') {
      const entires = Object.entries(this.recycledForm.value);
      const resultArray: any = [];
      let i = {};
      const entiresArray = this.adminRecycledData.indicatiorList.map((obj: any, index: any) => ({
        ...obj,
        ...entires[index],
      }));
      entiresArray.forEach((event: any, index: any) => {
        i = {
          indicatorId: event.indicatorId,
          name: event.name,
          unit: event.unit,
          defaultValue: event[1],
          equivalencyUnits: event.equivalencyUnits,
          multiplier: event.multiplier,
        };
        resultArray.push(i);
      });
      const recyclePayload = {
        materialId: this.recycledAddEditForm.controls['material'].value,
        regionId:
          this.recycledAddEditForm.controls['region'].value?.id || this.adminRecycledData.regionId,
        organizationId:
          this.recycledAddEditForm.controls['organizationName'].value?.name ==
          '--All organization -- '
            ? null
            : this.recycledAddEditForm.controls['organizationName'].value?.id,
        indicatiorList: resultArray,
      };
      this.saveNewRecycleMaterialEvent.emit(recyclePayload);
      this.onClose();
    }
  }

  onClose() {
    this.modal.close();
  }

  commonInputSearch(term: string, item: any) {
    return item.description.toLowerCase().includes(term.toLowerCase());
  }

  orgInputSearch(term: string, item: any) {
    return item.name.toLowerCase().includes(term.toLowerCase());
  }
}
